module.exports = __webpack_public_path__ + "../resources/images/attach-91ee4c9d6406386b1dcf60138a873730.svg";